import {Platform} from 'react-native';

export const blur = () => {
  if (Platform.OS !== 'web') {
    return;
  }
  if (window.document.activeElement) {
    (window.document.activeElement as any).blur();
  }
};
